import React from "react";
import { useTranslation } from "react-i18next";
import MainInput from "../Elements/MainInput/MainInput";
import LinkButton from "../Elements/LinkButton/LinkButton";
import MainButton from "../Elements/MainButton/MainButton";
import ErrorMessage from "../Elements/ErrorMessage/ErrorMessage";
import "./AuthFormsCommon.css";

const AuthForgotPasswordFlow = ({
  forgotPasswordStage,
  resetStatus,
  envelopeIcon,
  lockIcon,
  hashtag,
  eye,
  eyeOff,
  email,
  resetCode,
  newPassword,
  showPassword,
  error,
  onEmailChange,
  onResetCodeChange,
  onNewPasswordChange,
  onTogglePassword,
  onSendResetEmail,
  onResetPassword,
  onBackToLogin,
  onCloseError,
}) => {
  const { t } = useTranslation();

  if (forgotPasswordStage === "email") {
    return (
      <>
        <LinkButton onClick={onBackToLogin}>{t("auth.backToLogin", "Back to Login")}</LinkButton>
        <p className="info-text">{t("auth.enterEmailResetInfo", "Enter your email to get a reset code:")}</p>
        <div className="input-with-icon">
          <img src={envelopeIcon} className="input-icon" alt="email icon" />
          <MainInput
            placeholder={t("auth.email", "Email")}
            type="email"
            autoComplete="new-email"
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
          />
        </div>
        <MainButton className="single-btn-margin" onClick={onSendResetEmail}>
          {t("auth.sendCode", "Send Code")}
        </MainButton>
        {error && <ErrorMessage message={error} onClose={onCloseError} />}
      </>
    );
  }
  // forgotPasswordStage === "reset"
  return (
    <>
      <LinkButton onClick={onBackToLogin}>{t("auth.backToLogin", "Back to Login")}</LinkButton>

      {resetStatus === "sending" && <p className="info-text">{t("auth.sendingCode", "Sending code...")}</p>}
      {resetStatus === "sent" && <p className="info-text">{t("auth.codeSentEmail", "Code sent to your email")}</p>}
      {resetStatus === "error" && (
        <p className="info-text error-text">{t("auth.errorSendingCode", "Error sending code")}</p>
      )}
      <div className="input-with-icon">
        <img src={hashtag} className="input-icon" alt="code icon" />
        <MainInput
          placeholder={t("auth.resetCode", "Reset code")}
          value={resetCode}
          onChange={(e) => onResetCodeChange(e.target.value)}
          autoComplete="off"
        />
      </div>
      <div className="input-with-icon">
        <img src={lockIcon} className="input-icon" alt="lock icon" />
        <MainInput
          placeholder={t("auth.newPassword", "New password")}
          type={showPassword ? "text" : "password"}
          value={newPassword}
          autoComplete="new-password"
          onChange={(e) => onNewPasswordChange(e.target.value)}
        />
        {newPassword.length > 0 && (
          <img
            src={showPassword ? eyeOff : eye}
            className="input-icon"
            alt={showPassword ? "hide password" : "show password"}
            onClick={onTogglePassword}
            style={{
              right: "1.3rem",
              left: "auto",
              cursor: "pointer",
            }}
          />
        )}
      </div>
      <MainButton
        onClick={onResetPassword}
        disabled={resetStatus !== "sent"}
        className={`${resetStatus !== "sent" ? "disabled-btn" : ""} single-btn-margin`.trim()}
      >
        {t("auth.resetPassword", "Reset Password")}
      </MainButton>
      {error && <ErrorMessage message={error} onClose={onCloseError} />}
    </>
  );
};
export default AuthForgotPasswordFlow;
